export default class Notifications {
   constructor(unreadCount = 0) {
      this._unreadCount = unreadCount;
   }

   getUnreadCount = () => this._unreadCount;

   clone() {
      return new Notifications(this._unreadCount);
   }

   setAllNotificationsAsRead() {
      this._unreadCount = 0;
   }

   setNotificationAsRead = () => {
      this._unreadCount--;
   };

   addNewNotification = () => {
      this._unreadCount++;
   };

   initializeNotifications = unreadCount => {
      this._unreadCount = unreadCount;
   };
}
